import React from 'react';
import { Button, Col, Row } from 'react-bootstrap';
import { Field, Form, getIn, withFormik } from 'formik';
import * as Yup from 'yup';
import moment from 'moment';

import { BasicTextArea, UploadFile } from '../../../components';

const InsurancePolicyCancelForm = ({ errors, handleModalClose, onHide, setFieldValue, touched }) => {
  const cancellationDate = moment().format('DD/MM/YYYY');

  return (
    <Form>
      <Row>
        <Col xs={12} className="mt-3">
          <Field name="insurancePolicy[cancellation]">
            {({ field }) => (
              <UploadFile
                {...field}
                abbr
                label="Aprobación"
                onChange={file => setFieldValue(field.name, file)}
                error={getIn(errors, field.name)}
                touched={getIn(touched, field.name)}
              />
            )}
          </Field>
        </Col>
        <Col xs={12} className="mt-4">
          <Field name="insurancePolicy[comments]">
            {({ field }) => (
              <BasicTextArea
                {...field}
                row={4}
                label="Comentario"
                placeholder="Ingresa un comentario con los motivos de cancelación de la póliza para tus registros"
                className="p-3"
                error={getIn(errors, field.name)}
                touched={getIn(touched, field.name)}
              />
            )}
          </Field>
        </Col>
        <Col xs={12} className="d-flex justify-content-end mt-3">
          <p className="label">
            <span className="font-weight-bold">Fecha de cancelación:</span> {cancellationDate}
          </p>
        </Col>
      </Row>

      <Row className="mt-2">
        <Col md={6} className="mt-4">
          <Button block variant="cancel" className="no-shadow" onClick={handleModalClose}>
            Cerrar
          </Button>
        </Col>
        <Col md={6} className="mt-4">
          <Button block type="submit" variant="strong-danger" className="no-shadow" onClick={onHide}>
            Cancelar póliza
          </Button>
        </Col>
      </Row>
    </Form>
  );
};

const setInitialValues = ({ insurancePolicy }) => ({ insurancePolicy });

const validationSchema = Yup.object().shape({
  insurancePolicy: Yup.object().shape({
    cancellation: Yup.mixed().required('Debes adjuntar una aprobación'),
    comments: Yup.string().nullable()
  })
});

const handleSubmit = (values, { props }) => {
  const { formRequest, onHide } = props;
  formRequest(values);
  if (onHide) onHide();
};

export default withFormik({
  mapPropsToValues: setInitialValues,
  handleSubmit,
  validationSchema,
  enableReinitialize: true,
  validateOnMount: props => props.action !== 'new'
})(InsurancePolicyCancelForm);
